const BaseRanges = {
  xs: {
    min: 0,
    max: 370
  },
  sm: {
    min: 370.01,
    max: 750
  },
  md: {
    min: 750.01,
    max: 1023
  },
  lg: {
    min: 1023.01,
    max: 1199
  },
  xl: {
    min: 1199.01,
    max: 1499
  },
  xxl: {
    min: 1499.01,
    max: Infinity
  }
};
const ResponsiveRanges = {
  ...BaseRanges,
  smMin: {
    min: BaseRanges.sm.min,
    max: Infinity
  },
  smMax: {
    min: 0,
    max: BaseRanges.sm.max
  },
  mdMin: {
    min: BaseRanges.md.min,
    max: Infinity
  },
  mdMax: {
    min: 0,
    max: BaseRanges.md.max
  },
  lgMin: {
    min: BaseRanges.lg.min,
    max: Infinity
  },
  lgMax: {
    min: 0,
    max: BaseRanges.lg.max
  },
  xlMin: {
    min: BaseRanges.xl.min,
    max: Infinity
  },
  xlMax: {
    min: 0,
    max: BaseRanges.xl.max
  }
};

export { BaseRanges, ResponsiveRanges };
//# sourceMappingURL=responsive.js.map
